import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import moment from 'moment';
import apiRequest from './hooks/apiRequest';

export default function ClaimActivity({ visible }) {
  const [claimActivity, setClaimActivity] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!visible) return;   
    const fetchClaimInfo = async () => {
      setLoading(true);
      const claimId = localStorage.getItem('claimId');

      try {
        const claimRes = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/GetClaimById/' + claimId,
          'GET'
        );
        setClaimActivity(claimRes?.data?.result?.claim_activity);

      } catch (error) {
        console.error('Error fetching claim details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClaimInfo();
  }, [visible]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'user_name',
      key: '1',
    },
    {
      title: 'Status',
      dataIndex: 'claim_status',
      key: '2',
    },
    {
      title: 'Claim Notes',
      dataIndex: 'claim_notes',
      key: '3',
    },
    {
      title: 'Date Modified',
      dataIndex: 'created_date',
      key: '4',
      render: created_date => moment(created_date).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <>
      <div className="dash-bg-white" style={{ marginTop: 30 }}>
        <h3 style={{ color: '#F15A2B', fontWeight: 700, fontSize: 20, marginBottom: 20 }}>
          Claim Activity
        </h3>
        <Table
          dataSource={claimActivity}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
    </>
  );
}
